import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useMyMaterials() {
    return useQuery({
        queryKey: ['student-materials'],
        queryFn: () => apiClient('/materials/me'),
        staleTime: 1000 * 60 * 10,
    });
}
//# sourceMappingURL=useMyMaterials.js.map